webpackJsonp([121795138602394],{

/***/ 1373:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CageInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"locationId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"maxWeight","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"defaultValue":null,"description":null,"name":"minWeight","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"species","type":{"kind":"LIST","name":null,"ofType":{"kind":"SCALAR","name":"String","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-cage-input-06950cb1a2639423a639.js